export default __webpack_public_path__ + "static/media/WelcomePageStep3.fd8c9edb.png";